import '../style/side-navigation-CywqDKL_.css'
import { computed as c, ref as b, defineComponent as V, useCssVars as Y, inject as K, openBlock as s, createBlock as f, unref as a, normalizeClass as _, withCtx as L, createCommentVNode as k, createElementVNode as O, toDisplayString as Z, normalizeProps as R, mergeProps as U, renderSlot as E, createElementBlock as h, createVNode as T, normalizeStyle as Q, Fragment as N, renderList as P, toRefs as ee, useModel as te, provide as ie, createSlots as q, guardReactiveProps as x } from "vue";
import { SIDE_NAVIGATION_PROVIDER as G } from "./constant/providers.js";
import { UPDATE_MODEL_VALUE as J } from "./constant/events.js";
import { isLinkActive as w } from "./utils/link.js";
import { pxlize as M } from "x-utils";
import { useBorderBoxElementSize as H } from "./hooks/useBorderBoxElementSize.js";
import { useScrollerClassList as ne } from "./hooks/useScroller.js";
import oe from "./divider.js";
import j from "./icon.js";
import le from "./badge.js";
import se from "./link.js";
import { DEFAULT_RIPPLE_SETTING as re } from "./constant/ripple.js";
function ae(u) {
  const { items: n, url: o } = u, r = c(() => n.value.map((e) => {
    const m = e.type ?? "item";
    if (m === "item")
      return {
        ...e,
        type: m,
        active: w(e.to, o.value)
      };
    if (m === "group" && e.children) {
      const v = e.children.some((l) => w(l.to, o.value));
      return {
        ...e,
        active: v,
        children: e.children.map((l) => ({
          ...l,
          type: l.type ?? "item",
          active: w(l.to, o.value)
        }))
      };
    }
    return {
      ...e,
      active: !1
    };
  })), d = c(() => r.value.filter((e) => !e.fixed)), t = c(() => r.value.filter((e) => e.fixed === "top")), i = c(() => r.value.filter((e) => e.fixed === "bottom"));
  return {
    topItems: t,
    middleItems: d,
    bottomItems: i
  };
}
function W(u) {
  const { layout: n } = u, o = b(null), r = b(null), d = b(null), t = b(null), { height: i } = H(o), { height: e } = H(r), { height: m } = H(d), { height: v } = H(t), { classList: l } = ne({ fat: !0, showScrollbarOnHover: !0 }), $ = c(() => {
    const I = ["e-side-navigation"];
    return n === "mobile" && I.push("e-side-navigation--mobile"), I;
  }), p = c(() => n === "mobile" ? {
    icon: "chevron-down",
    color: "var(--common-tertiary)"
  } : {
    icon: "caret-down"
  }), y = c(() => i.value - e.value - v.value), S = c(() => m.value >= y.value), A = c(() => y.value > 0 ? { maxHeight: M(y.value) } : {}), B = c(() => S.value ? l.value : []);
  return {
    container: o,
    topItemsContainer: r,
    middleItemsContainer: d,
    bottomItemsContainer: t,
    containerClassList: $,
    scrollable: S,
    middleItemsStyle: A,
    middleItemsClassList: B,
    groupIconProps: p
  };
}
function ce(u) {
  const { layout: n, level: o } = u;
  return n === "mobile" && o === 2 ? 40 : 48;
}
const de = ["title"], F = /* @__PURE__ */ V({
  __name: "side-title",
  props: {
    title: {},
    icon: {},
    level: {},
    to: {},
    badge: {},
    paddingLeft: {},
    handler: { type: Function }
  },
  emits: ["click"],
  setup(u) {
    Y((i) => ({
      "74e7e5c2": r.value,
      fb165d5a: t.value
    }));
    const n = u, { layout: o } = K(G), r = c(() => M(ce({ layout: o, level: n.level }))), d = c(() => {
      const i = ["e-side-navigation__title", `level${n.level}`];
      return n.icon && i.push("with-icon"), i;
    }), t = c(() => n.paddingLeft ?? "var(--side-navigation-item-padding-left)");
    return (i, e) => (s(), f(a(se), {
      class: _(d.value),
      ripple: a(re),
      to: i.to,
      onClick: e[0] || (e[0] = (m) => i.$emit("click"))
    }, {
      default: L(() => [
        i.icon ? (s(), f(a(j), {
          key: 0,
          class: "e-side-navigation__icon",
          icon: i.icon
        }, null, 8, ["icon"])) : k("", !0),
        O("span", { title: i.title }, Z(i.title), 9, de),
        i.badge ? (s(), f(a(le), R(U({ key: 1 }, i.badge)), null, 16)) : k("", !0),
        E(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "ripple", "to"]));
  }
}), ue = /* @__PURE__ */ V({
  __name: "side-group",
  props: {
    title: {},
    icon: {},
    opened: { type: Boolean },
    badge: {},
    items: {}
  },
  emits: ["title-click", "item-click"],
  setup(u, { emit: n }) {
    const o = u, { layout: r } = K(G), d = n, t = b(!1), { groupIconProps: i } = W({ layout: r }), e = c(() => {
      const l = r === "mobile" ? 40 : 48;
      return {
        height: t.value ? M(o.items.length * l) : 0,
        opacity: t.value ? 1 : 0
      };
    }), m = () => {
      t.value = !t.value, d("title-click");
    }, v = (l) => {
      d("item-click", l);
    };
    return (l, $) => (s(), h("div", {
      class: _(["e-side-navigation__group", { expanded: t.value }])
    }, [
      T(F, {
        title: l.title,
        icon: l.icon,
        badge: l.badge,
        level: 1,
        onClick: m
      }, {
        default: L(() => [
          T(a(j), U(a(i), {
            rotation: t.value ? -180 : 0,
            class: "e-side-navigation__group-icon"
          }), null, 16, ["rotation"])
        ]),
        _: 1
      }, 8, ["title", "icon", "badge"]),
      O("div", {
        class: "e-side-navigation__group-items",
        style: Q(e.value)
      }, [
        (s(!0), h(N, null, P(l.items, (p) => (s(), h(N, {
          key: p.to
        }, [
          p.type === "item" ? (s(), f(F, {
            key: 0,
            title: p.text,
            icon: p.icon,
            badge: p.badge,
            to: p.to,
            level: 2,
            class: _({ active: p.active }),
            onClick: (y) => v(p)
          }, null, 8, ["title", "icon", "badge", "to", "class", "onClick"])) : k("", !0)
        ], 64))), 128))
      ], 4)
    ], 2));
  }
}), me = {
  key: 3,
  class: "e-side-navigation__slot"
}, z = /* @__PURE__ */ V({
  __name: "side-items",
  props: {
    items: {},
    titleClickHandler: { type: Function }
  },
  setup(u) {
    const n = u, o = c(() => n.items.some((t) => t.icon)), r = c(() => o.value ? void 0 : "var(--space-16)"), d = (t) => {
      n.titleClickHandler && n.titleClickHandler(t);
    };
    return (t, i) => (s(!0), h(N, null, P(t.items, (e, m) => (s(), h(N, { key: m }, [
      e.type === "item" ? (s(), f(F, {
        key: 0,
        title: e.text,
        icon: e.icon,
        badge: e.badge,
        to: e.to,
        "padding-left": r.value,
        class: _({ active: e.active }),
        handler: e.handler,
        level: 1,
        onClick: (v) => d(e)
      }, {
        default: L(() => [
          e.rightIcon ? (s(), f(a(j), U({
            key: 0,
            ref_for: !0
          }, typeof e.rightIcon == "string" ? { icon: e.rightIcon } : e.rightIcon, { class: "e-side-navigation__right-icon" }), null, 16)) : k("", !0)
        ]),
        _: 2
      }, 1032, ["title", "icon", "badge", "to", "padding-left", "class", "handler", "onClick"])) : e.type === "group" && e.children ? (s(), f(ue, {
        key: 1,
        title: e.text,
        icon: e.icon,
        badge: e.badge,
        items: e.children,
        class: _({ active: e.active }),
        onTitleClick: (v) => d(e),
        onItemClick: d
      }, null, 8, ["title", "icon", "badge", "items", "class", "onTitleClick"])) : e.type === "divider" ? (s(), f(a(oe), {
        key: 2,
        class: "e-side-navigation__divider"
      })) : e.type === "slot" ? (s(), h("div", me, [
        E(t.$slots, e.slotName)
      ])) : k("", !0)
    ], 64))), 128));
  }
}), Se = /* @__PURE__ */ V({
  name: "e-side-navigation",
  __name: "side-navigation",
  props: {
    modelValue: {},
    layout: { default: "desktop" },
    items: {}
  },
  emits: [J, "item-click"],
  setup(u, { emit: n }) {
    const o = u, r = n, { items: d } = ee(o), t = te(o, "modelValue"), i = o.layout, {
      topItems: e,
      middleItems: m,
      bottomItems: v
    } = ae({ items: d, url: t }), {
      container: l,
      topItemsContainer: $,
      middleItemsContainer: p,
      bottomItemsContainer: y,
      containerClassList: S,
      middleItemsStyle: A,
      middleItemsClassList: B
    } = W({
      layout: i
    });
    ie(G, {
      layout: i
    });
    const I = (g) => {
      g.handler && g.handler(), g.to && r(J, t), r("item-click", g);
    };
    return (g, pe) => (s(), h("div", {
      ref_key: "container",
      ref: l,
      class: _(a(S))
    }, [
      a(e).length ? (s(), f(z, {
        key: 0,
        ref_key: "topItemsContainer",
        ref: $,
        class: "e-side-navigation__items--middle",
        items: a(e),
        "title-click-handler": I
      }, null, 8, ["items"])) : k("", !0),
      O("div", {
        ref_key: "middleItemsContainer",
        ref: p,
        class: _(["e-side-navigation__items--middle", a(B)]),
        style: Q(a(A))
      }, [
        T(z, {
          items: a(m),
          "title-click-handler": I
        }, q({ _: 2 }, [
          P(g.$slots, (X, C) => ({
            name: C,
            fn: L((D) => [
              E(g.$slots, C, R(x(D)))
            ])
          }))
        ]), 1032, ["items"])
      ], 6),
      a(v).length ? (s(), h("div", {
        key: 1,
        ref_key: "bottomItemsContainer",
        ref: y,
        class: "e-side-navigation__items--bottom"
      }, [
        T(z, {
          items: a(v),
          "title-click-handler": I
        }, q({ _: 2 }, [
          P(g.$slots, (X, C) => ({
            name: C,
            fn: L((D) => [
              E(g.$slots, C, R(x(D)))
            ])
          }))
        ]), 1032, ["items"])
      ], 512)) : k("", !0)
    ], 2));
  }
});
export {
  Se as default
};
//# sourceMappingURL=side-navigation.js.map
